module.exports = {
      id: "play-usage",
      viewBox: "0 0 30.542 30.542",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#play",
      toString: function () {
        return this.url;
      }
    }